// extracted by mini-css-extract-plugin
module.exports = {"logo-wrapper":"Logo_logo-wrapper__1B0t9"};